import React, { FC } from 'react';
import { Money } from '../../../../../../../Money';
import { Money as MoneyType } from '../../../../../../../types';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../../../../../theme';
import cn from 'classnames';

interface Props {
	className?: string;
	price: MoneyType;
}

const Taxes: FC<Props> = ({ className, price }) => {
	const { t } = useTranslation('FareGroup');
	const { Taxes: css } = useTheme('Entities').FareGroupV2;

	return (
		<div className={cn(css.root, className)}>
			{t('Taxes and fees')}: <Money money={price} />
		</div>
	);
};

export default Taxes;
